import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { jwtInterceptor } from './core/auth/services/auth.interceptor';
import { provideSessionContext, sessionContextInterceptor } from './core/services/session-context';
import { environment } from '@env/environment';
import { AnalysisDetailStore } from '@features/analyses/store/analysis-detail.store';

// The UI is German throughout, so `| number` / `| date` must render de-DE
// (1.234,56) rather than Angular's en-US default (1,234.56).
registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideBrowserGlobalErrorListeners(),
    provideSessionContext(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([jwtInterceptor, sessionContextInterceptor])),
    AnalysisDetailStore,
  ],
};
